module.exports = __webpack_public_path__ + "static/fonts/Poppins-BlackItalic.e9c5c58.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-BlackItalic.ttf
// module id = 1018
// module chunks = 11